import { Injectable } from '@angular/core';
import { WebServicesService } from '../web-services/web-services.service';
import { Page } from '../web-services/page.model';
import { PagedData } from '../web-services/paged-data.model';
import { TranslateService } from '@ngx-translate/core';
import { Application } from './application.model';
import { NotificationService } from '../../service/notification/notification.service';

@Injectable({
	providedIn: 'root'
})
export class ApplicationService {

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private webServicesService: WebServicesService
	) { }

	/* Appels aux webServices */

	// TODO: traduire le nom
	public getApplications(page?: Page, sort?: string, dir?: string): Promise<PagedData<Application>> {
		console.log('RÃ©cupÃ©ration des applications');
		let promise: Promise<PagedData<Application>>;
		if (page) {
			if (sort && dir) {
				promise = this.webServicesService.getList<Application>('/application?size=' + page.size + '&page=' + page.number + '&sort=' + sort + ',' + dir);
			} else {
				promise = this.webServicesService.getList<Application>('/application?size=' + page.size + '&page=' + page.number);
			}
		}
		else {
			promise = this.webServicesService.getList<Application>('/application');
		}
		return promise
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('GET_APPS_ERROR'));
				return Promise.reject(error);
			})
	}

	public postApplication(application: Application): Promise<Application> {
		console.log('Ajout d\'une nouvelle application');
		let json = {
			name: application.name,
			logo: application.logo,
			adminUrl: application.adminUrl,
			appUrl: application.appUrl
		}
		return this.webServicesService.post<Application>('/application', json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public patchApplication(application: Application): Promise<Application> {
		console.log('Modification de l\'application ' + application.id);
		let json = {
			name: application.name,
			logo: application.logo,
			adminUrl: application.adminUrl,
			appUrl: application.appUrl
		}
		return this.webServicesService.patch<Application>('/application/' + application.id, json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public deleteApplication(applicationId: string) {
		console.log("Suppression de l\'application " + applicationId);
		return this.webServicesService.delete('/application/' + applicationId)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}
}
